<template>
  <pt-balance-manage class="pt-balance-manage__page"></pt-balance-manage>
</template>

<script>
import PtBalanceManage from 'cps/new-to-old-audit/pt-balance-manage/withData'
export default {
  name: 'pt-balance-manage__view',
  components: {
    'pt-balance-manage': PtBalanceManage
  }
}
</script>
